/* ETOKENS */
export const GET_ETOKENS = "GET_ETOKENS";
export const GET_ETOKENS_SUCCESS = "GET_ETOKENS_SUCCESS";
export const GET_ETOKENS_FAIL = "GET_ETOKENS_FAIL";

export const SET_SELECTED_ETOKEN = "SET_SELECTED_ETOKEN";
